



































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

interface Item {
  key: string | number;
  type: string;
  children: Item[];
}

@Component({
  name: 'AmenitiesList',
})
export default class AmenitiesList extends Vue {
  @Prop() items!: [];
  @PropSync('form', { default: () => ({}) }) formFields!: never;
  @Prop({ default: () => [] }) schema!: never[];
  @Prop({}) parentKey!: never;
  @Prop({}) parent!: never;
  @Prop({}) parentIsGroup!: never;

  getRadioValue(item: Item) {
    if (!this.formFields[item.key]) this.$set(this.formFields, item.key, item.children[0].key);
    return this.formFields[item.key];
  }

  setValue(item: Item, val: string | number | boolean) {
    if (item.children) {
      switch (item.type) {
        case 'checkbox': {
          this.$set(this.formFields, item.key, val ? {} : undefined);
          break;
        }
        case 'radioGroup': {
          this.$set(this.formFields, item.key, val);
          break;
        }
        case 'select': {
          this.$set(this.formFields, item.key, val);
          break;
        }
        case 'radio': {
          this.$set(this.formFields, this.parentKey, val);
          break;
        }
        case 'dateComponent': {
          this.$set(this.formFields, item.key, val);
          break;
        }
      }
    } else {
      switch (item.type) {
        case 'checkbox': {
          this.$set(this.formFields, item.key, val);
          break;
        }
        case 'radio': {
          this.$set(this.formFields, this.parentKey, val);
          break;
        }
        case 'number': {
          this.$set(this.formFields, item.key, val);
          break;
        }
      }
    }
  }
}
